import React, { useEffect, useState } from 'react';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import {
  Box,
  Typography,
  Button,
  CircularProgress,
} from '@mui/material';
import { CheckCircle, Error as ErrorIcon } from '@mui/icons-material';
import Page from '../../components/Layout/Page';
import { useStyles } from './styles';

const WebpayResult: React.FC = () => {
  const classes = useStyles();
  const { studentId } = useParams<{ studentId: string }>();
  const history = useHistory();
  const location = useLocation();
  const [loading, setLoading] = useState<boolean>(true);

  const searchParams = new URLSearchParams(location.search);
  const status = searchParams.get('status');
  const token = searchParams.get('token_ws');

  useEffect(() => {
    setLoading(false);
  }, [location, studentId, status, token]);

  if (loading) {
    return (
      <Page title="Procesando pago">
        <Box className={classes.loadingContainer}>
          <CircularProgress />
          <Typography variant="h6" style={{ marginTop: 16 }}>
            Procesando resultado del pago...
          </Typography>
        </Box>
      </Page>
    );
  }

  if (!token || !status) {
    return (
      <Page title="Error en el pago">
        <Box className={classes.container}>
          <Box style={{ textAlign: 'center', padding: '40px 20px' }}>
            <ErrorIcon
              style={{ fontSize: 80, color: '#f44336', marginBottom: 20 }}
            />
            <Typography variant="h4" style={{ marginBottom: 16, color: '#f44336' }}>
              Error al procesar el pago
            </Typography>
            <Typography variant="body1" style={{ marginBottom: 24, color: '#666' }}>
              No se pudo obtener la información del pago. Por favor, verifica el estado
              de tu pago o contacta con soporte.
            </Typography>
            <Box style={{
              display: 'flex',
              gap: 16,
              justifyContent: 'center',
              flexWrap: 'wrap',
            }}
            >
              {studentId ? (
                <>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => history.push(`/inscripcion/alumno/${studentId}/pago`)}
                    size="large"
                  >
                    Volver al pago
                  </Button>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => history.push(`/inscripcion/alumno/${studentId}`)}
                    size="large"
                  >
                    Volver
                  </Button>
                </>
              ) : (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => history.push('/inscripcion')}
                  size="large"
                >
                  Volver
                </Button>
              )}
            </Box>
          </Box>
        </Box>
      </Page>
    );
  }

  const isSuccess = status === 'approved';

  return (
    <Page title={isSuccess ? 'Pago exitoso' : 'Pago rechazado'}>
      <Box className={classes.container}>
        <Box style={{ textAlign: 'center', padding: '40px 20px' }}>
          {isSuccess ? (
            <>
              <CheckCircle
                style={{ fontSize: 80, color: '#4caf50', marginBottom: 20 }}
              />
              <Typography variant="h4" style={{ marginBottom: 16, color: '#4caf50' }}>
                ¡Pago realizado exitosamente!
              </Typography>
              <Typography variant="body1" style={{ marginBottom: 24, color: '#666' }}>
                Tu matrícula ha sido confirmada. Recibirás un correo de confirmación pronto.
              </Typography>
            </>
          ) : (
            <>
              <ErrorIcon
                style={{ fontSize: 80, color: '#f44336', marginBottom: 20 }}
              />
              <Typography variant="h4" style={{ marginBottom: 16, color: '#f44336' }}>
                Pago rechazado
              </Typography>
              <Typography variant="body1" style={{ marginBottom: 24, color: '#666' }}>
                El pago no pudo ser procesado. Por favor,
                verifica los datos de tu tarjeta o intenta con otro método de pago.
              </Typography>
            </>
          )}

          <Box style={{
            display: 'flex',
            gap: 16,
            justifyContent: 'center',
            flexWrap: 'wrap',
          }}
          >
            {isSuccess ? (
              <Button
                variant="contained"
                color="primary"
                onClick={() => history.push(`/inscripcion/alumno/${studentId}`)}
                size="large"
              >
                Volver al plan de estudios
              </Button>
            ) : (
              <>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => history.push(`/inscripcion/alumno/${studentId}/pago`)}
                  size="large"
                >
                  Intentar nuevamente
                </Button>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => history.push(`/inscripcion/alumno/${studentId}`)}
                  size="large"
                >
                  Volver
                </Button>
              </>
            )}
          </Box>
        </Box>
      </Box>
    </Page>
  );
};

export default WebpayResult;
